"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useSetDeepDive = function useSetDeepDive(vertical, type, dispatchApp) {
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      redirect = _useState2[0],
      setRedirect = _useState2[1];

  var handleTypeChoice = function handleTypeChoice() {
    switch (type) {
      // Credit Cards
      case 'low_interest':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Low Interest'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'cash_back':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Cash Back'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'reward':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: 'rewards',
            crumb: 'Reward'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'student':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Student'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'travel':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Travel'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'credit_building':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Credit Building'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'business':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Business'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'balance_transfer':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Balance Transfer'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'prepaid':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Prepaid'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;
      // Auto Loans

      case 'car':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Car'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'truck':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Truck'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'suv':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'SUV'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'van':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Van/Minivan'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'not_sure':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Not Sure'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;
      // Personal Loans

      case 'debt_consolidation':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Debt Condolidation'
          }
        });
        setRedirect('/debt_types');
        return;

      case 'pay_bills':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Paying Bills'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'make_purchase':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Making a Purchase'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'emergency':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: 'emergency_cash',
            crumb: 'Emergency Cash'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'taxes':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: 'pay_taxes',
            crumb: 'Paying Taxes'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'other':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: 'other_purpose',
            crumb: 'Other'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;
      // Home Loans

      case 'refinance':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Refinancing'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'heloc':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'HELOC'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'lease':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: 'lease_to_own',
            crumb: 'Lease-To-Own'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'purchase':
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Purchasing a Home'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      default:
        return;
    }
  };

  var checkForDeepDive = function checkForDeepDive() {
    switch (vertical) {
      case 'credit_cards':
        dispatchApp({
          type: 'VERTICAL_PICKED',
          payload: {
            value: vertical,
            crumb: 'Credit Cards'
          }
        });

        if (type !== 'N/A') {
          handleTypeChoice();
          return;
        }

        ;
        setRedirect('/credit_cards');
        return;

      case 'auto_loans':
        dispatchApp({
          type: 'VERTICAL_PICKED',
          payload: {
            value: vertical,
            crumb: 'Auto Loans'
          }
        });

        if (type !== 'N/A') {
          handleTypeChoice();
          return;
        }

        ;
        setRedirect('/auto_loans');
        return;

      case 'personal_loans':
        dispatchApp({
          type: 'VERTICAL_PICKED',
          payload: {
            value: vertical,
            crumb: 'Personal Loans'
          }
        });

        if (type !== 'N/A') {
          handleTypeChoice();
          return;
        }

        ;
        setRedirect('/personal_loans');
        return;

      case 'home_loans':
        dispatchApp({
          type: 'VERTICAL_PICKED',
          payload: {
            value: vertical,
            crumb: 'Home Loans'
          }
        });

        if (type !== 'N/A') {
          handleTypeChoice();
          return;
        }

        ;
        setRedirect('/home_loans');
        return;

      case 'direct':
        dispatchApp({
          type: 'VERTICAL_PICKED',
          payload: {
            value: vertical,
            crumb: 'Select Interest'
          }
        });
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: 'Direct Offer'
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      case 'lincx':
        dispatchApp({
          type: 'VERTICAL_PICKED',
          payload: {
            value: vertical,
            crumb: 'Personal Loans'
          }
        });
        dispatchApp({
          type: 'LOAN_TYPE_PICKED',
          payload: {
            value: type,
            crumb: "Inter-Lincx-".concat(type)
          }
        });
        dispatchApp({
          type: 'REDIRECTION'
        });
        setRedirect('/email_optin');
        return;

      default:
        return;
    }
  };

  (0, _react.useEffect)(function () {
    checkForDeepDive(); // eslint-disable-next-line
  }, []);
  return redirect;
};

var _default = useSetDeepDive;
exports.default = _default;

//# sourceMappingURL=useSetDeepDive.jsx.map